<template>
  <div class="animate__animated animate__fadeInDown">
    <div class="split-me"></div>
  </div>
</template>

<script>

export default {
  name: "aboutMe",
  components: {},
  props: ['isShow'],
  data() {
    return {
      isBlogPlc: false,
      isBlogSummary: true,
    }
  },
  methods: {},
  watch: {}
}
</script>

<style scoped>
.split-me{
  margin-top: 15px;
}
</style>